import axios from "axios";

/** Helper function to call the getSingleChoice endpoint. */
export const getChoicesFromBFF = async (fieldId: string) => {
  const _payload = {
    service: "emarsysv2",
    payload: {
      endpoint: "getSingleChoice",
      fieldId: fieldId,
    },
  };

  const response = await axios.post("/_plat/api/v1/bff", _payload, {
    timeout: 10000,
  });

  const data = response.data.body;

  if (!data.success) {
    console.error("getChoiceDataFromEmarsys error", data); // eslint-disable-line no-console

    return null;
  }

  return data.data;
};
